import PopupBase from "./PopupBase";
import SelectGroup from "../group/SelectGroup";
import GroupApi from "../../api/GroupApi";
import SlotApi from "../../api/SlotApi";
import DebounceBtn from "../common/DebounceBtn";

import { useState } from 'react';


const GroupPop = props => {
    const { selectedSlots=[], groups=[], closed = () => {} } = props;
    const [ selectedGroupId, setSelectedGroupId ] = useState('');
    const [ groupNm , setGroupNm ] = useState('');

    const handleGroupNmInput = e => {
        setGroupNm(e.target.value);
    }

    const handleUpdateBtn = async () => {
         const rslt = await SlotApi.updateSlotsGroup(selectedSlots.map(slot => slot.slotId), selectedGroupId)
         closed(rslt && rslt.code === 'success');        
    }

    const handleCreateBtn = async () => {
        await GroupApi.createGroup({ groupNm });
        closed(true);        
    }

    return (
        <PopupBase closed={closed}>
            <div className="group-info">
                <h3>그룹정보 변경</h3>
                <div className="group-row">
                    <SelectGroup selectCallback={setSelectedGroupId} groups={groups} />
                    <button className="update-btn" onClick={handleUpdateBtn}>수정</button>
                </div>
            </div>
        </PopupBase>
    )
}

export default GroupPop;